<ion-header [translucent]="true" class="ion-no-border brochure-header">
  <div class="brochure-header-inner">
    <div class="brochure-header-left">
      <div class="brochure-header-icon-box">
        <ion-icon name="document-text-outline"></ion-icon>
      </div>
      <div>
        <ion-text class="brochure-header-kicker">Project Asset</ion-text>
        <ion-text class="brochure-header-title">Upload Brochure</ion-text>
      </div>
    </div>
    <button class="brochure-close-btn" (click)="close()" title="Close">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
</ion-header>

<ion-content class="brochure-content">
  <div class="brochure-body">

    <!-- Hidden file input -->
    <input hidden type="file"
      accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
      #filepickerBroucher (change)="fileSelectedBrochure($event)" />

    <!-- Upload Drop Zone -->
    <div class="brochure-section">
      <div class="section-label-row">
        <ion-icon name="cloud-upload-outline" class="section-label-icon"></ion-icon>
        <ion-text class="section-label-text">New Upload</ion-text>
      </div>

      @if (selectedBrouchur?.length > 0) {
        <!-- Selected File Preview -->
        <div class="file-preview-card">
          <div class="file-preview-icon-wrap">
            <ion-icon name="document-attach-outline" class="file-type-icon"></ion-icon>
          </div>
          <div class="file-preview-info">
            <span class="file-preview-name">{{ fileName }}</span>
            <span class="file-preview-meta">
              <ion-icon name="scale-outline"></ion-icon>
              {{ (selectedBrouchur[0].size / 1024) | number:'1.0-2' }} KB
            </span>
          </div>
          <button class="file-remove-btn" (click)="removeBrochureFile(0)" title="Remove file">
            <ion-icon name="trash-outline"></ion-icon>
          </button>
        </div>
      } @else {
        <!-- Drop Zone -->
        <div class="upload-drop-zone" (click)="addFileBrochure()">
          <div class="drop-zone-icon-wrap">
            <ion-icon name="cloud-upload-outline" class="drop-zone-icon"></ion-icon>
          </div>
          <ion-text class="drop-zone-title">Click to browse files</ion-text>
          <ion-text class="drop-zone-hint">
            <ion-icon name="document-outline"></ion-icon>
            Supports PDF, DOC, DOCX
          </ion-text>
        </div>

        <button class="browse-files-btn" (click)="addFileBrochure()">
          <ion-icon name="folder-open-outline"></ion-icon>
          Browse Files
        </button>
      }
    </div>

    <!-- Existing Brochure Section -->
    <div class="brochure-section">
      <div class="section-label-row">
        <ion-icon name="archive-outline" class="section-label-icon"></ion-icon>
        <ion-text class="section-label-text">Current Brochure</ion-text>
      </div>

      @if (data.item.BrochureFileName) {
        <div class="existing-file-card">
          <div class="existing-file-icon-wrap">
            <ion-icon name="checkmark-circle-outline" class="existing-check-icon"></ion-icon>
            <ion-icon name="document-text-outline" class="existing-doc-icon"></ion-icon>
          </div>
          <div class="existing-file-info">
            <ion-text class="existing-file-label">Brochure on file</ion-text>
            <span class="existing-file-name">{{ data.item.BrochureFileName }}</span>
          </div>
          <button class="download-btn" (click)="downloadBrochureFile(data.item)" title="View or download brochure">
            <ion-icon name="open-outline"></ion-icon>
            View / Download
          </button>
        </div>
      } @else {
        <div class="no-file-state">
          <ion-icon name="document-outline" class="no-file-icon"></ion-icon>
          <ion-text class="no-file-label">No brochure uploaded yet</ion-text>
          <ion-text class="no-file-hint">Use the upload zone above to add a brochure.</ion-text>
        </div>
      }
    </div>

  </div>
</ion-content>

<ion-footer class="brochure-footer">
  <div class="brochure-footer-inner">
    <button class="footer-btn btn-cancel" (click)="close()">
      <ion-icon name="close-circle-outline"></ion-icon>
      Cancel
    </button>
    <button class="footer-btn btn-upload" [disabled]="selectedBrouchur.length == 0" (click)="uploadBrochure()">
      <ion-icon name="cloud-upload-outline"></ion-icon>
      Upload Brochure
    </button>
  </div>
</ion-footer>